<template>
  <div class="box">
    <div v-html="aliform" v-show="false"></div>
    <div class="top">
      <div class="title">精心打造专业合同，为合作保驾护航</div>
      <div class="search">
        <el-input v-model="listParm.keyword" placeholder="请输入搜索内容..."></el-input>
        <el-button class="button" type="primary" icon="el-icon-search" @click="onSearch"
          >查询</el-button
        >
      </div>
    </div>
    <div class="content defBorderRadius">
      <div class="content_top">
        <div class="content_top_row">
          <category v-model="listParm.categoryId" @change="onSearch" />
          <div class="btns">
            <img
              v-show="type === 'line'"
              @click="type = 'card'"
              src="@/assets/image/thinktank/btn_l_off.webp"
            />
            <img v-show="type === 'card'" src="@/assets/image/thinktank/btn_l_on.webp" />
            <img
              v-show="type === 'card'"
              @click="type = 'line'"
              src="@/assets/image/thinktank/btn_r_off.webp"
            />
            <img v-show="type === 'line'" src="@/assets/image/thinktank/btn_r_on.webp" />
          </div>
        </div>
        <div class="content_top_row">
          <div class="content_top_search">
            <div class="content_top_search_label">排序方式：</div>
            <div class="content_top_search_list">
              <div
                class="content_top_search_list_item"
                :class="{ active: listParm.orderBy === null }"
                @click="sortClick(null)"
              >
                热门推荐
              </div>
              <div
                class="content_top_search_list_item"
                :class="{ active: listParm.orderBy === 'price' }"
                @click="sortClick('price')"
              >
                价格排序
                <div
                  class="sort"
                  :class="{
                    isDown: listParm.orderBy === 'price' && listParm.asc,
                    isUp: listParm.orderBy === 'price' && !listParm.asc,
                  }"
                >
                  <div class="el-icon-sort-down down"></div>
                  <span class="el-icon-sort-up up"></span>
                </div>
              </div>
              <div
                class="content_top_search_list_item"
                :class="{ active: listParm.orderBy === 'createdAt' }"
                @click="sortClick('createdAt')"
              >
                最新上传

                <div
                  class="sort"
                  :class="{
                    isDown: listParm.orderBy === 'createdAt' && listParm.asc,
                    isUp: listParm.orderBy === 'createdAt' && !listParm.asc,
                  }"
                >
                  <div class="el-icon-sort-down down"></div>
                  <span class="el-icon-sort-up up"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_main">
        <el-table
          row-class-name="defTableRowStyle"
          header-row-class-name="defTableHeaderStyle"
          :data="list"
          style="width: 100%"
          v-show="type === 'line' && !listLoading"
          v-loading="listLoading"
        >
          <el-table-column label="合同名称">
            <template slot-scope="scope">
              <div style="font-size: 14px; font-weight: 500; color: #262626">
                {{ scope.row.subject }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <div>
                {{ scope.row.categoryName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <div style="color: #f45858">
                {{ scope.row.price | priceFormat }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="上传日期">
            <template slot-scope="scope">
              <div>
                {{ scope.row.updatedAt | timeFormat }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div class="setting">
                <div class="text" @click="yulan(scope.row)">预览</div>
                ｜
                <div class="text" @click="xiazai(scope.row)">下载</div>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <empty />
          </template>
        </el-table>
        <div class="card" v-show="type === 'card' && !listLoading">
          <thinktankItem
            :isBuy="false"
            :itemData="item"
            v-for="item in list"
            :key="item.tempId"
            @yulan="yulan(item)"
            @xiazai="xiazai(item)"
          />
          <empty v-if="!list.length" style="width: 100%" />
        </div>
        <div class="pagination">
          <el-pagination
            :current-page="parm.current"
            :page-sizes="[30, 40, 50, 60]"
            :page-size.sync="parm.size"
            popper-class="paginationTopStyle"
            background
            layout="total,  prev, pager, next, jumper"
            :total="parm.total"
            @size-change="sizeChange"
            @current-change="currentChange"
            :popper-options="{
              placement: 'top',
              boundariesPadding: 10,
            }"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <thinktanPopup ref="thinktanPopupRef" @onBuy="onBuy" />
    <buy ref="buyRef" @onSubmit="onSubmit" />
  </div>
</template>

<script>
import thinktankItem from "./thinktankItem.vue";
import getList from "@/mixins/getList";
import thinktanPopup from "./thinktanPopup.vue";
import buy from "@/components/buy.vue";
import category from "./category.vue";
export default {
  components: {
    thinktankItem,
    thinktanPopup,
    buy,
    category,
  },
  mixins: [getList],
  data() {
    return {
      parm: {
        size: 100,
        total: 0,
        current: 1,
      },
      listParm: {
        keyword: "",
        orderBy: null,
        asc: true,
        categoryId: null,
      },
      type: "card",
      aliform: "",
    };
  },
  mounted() {},
  methods: {
    // 排序点击
    sortClick(type) {
      if (type === null) {
        this.listParm.orderBy = null;
        this.listParm.asc = true;
      }
      if (type === "price") {
        if (this.listParm.orderBy === "price") {
          this.listParm.asc = !this.listParm.asc;
        } else {
          this.listParm.asc = true;
          this.listParm.orderBy = "price";
        }
      }
      if (type === "createdAt") {
        if (this.listParm.orderBy === "createdAt") {
          this.listParm.asc = !this.listParm.asc;
        } else {
          this.listParm.asc = true;
          this.listParm.orderBy = "createdAt";
        }
      }
      this.onSearch();
    },
    listApi(parm) {
      return this.$api.getContractTempList({ ...parm, ...this.listParm });
    },
    yulan(item) {
      this.$refs.thinktanPopupRef.onShow(item);
      console.log(item);
    },
    xiazai(item) {
      this.onBuy(item);
      console.log(item);
    },
    onBuy(item) {
      console.log(item);
      const { subject, price, tempId } = item;
      const chanpinList = [
        {
          name: subject,
          price,
          tempId,
        },
      ];
      this.$refs.buyRef.show({ chanpinList });
    },
    onSubmit(paymentMethod, chanpinList) {
      console.log(paymentMethod, chanpinList);
      const tempId = chanpinList[0].tempId;
      this.postContractTempBuy({ tempId, paymentMethod });
    },
    async postContractTempBuy(parm) {
      const { data, info, status } = await this.$api.postContractTempBuy(parm);
      if (status === 200 || status === 201) {
        this.$refs.buyRef.close();
        if (parm.paymentMethod === 2) {
          this.aliform = data;
          this.$nextTick(() => {
            const forms = Array.from(document.forms);
            const alipayForm = forms.find((form) =>
              form.action.includes("alipay.com/gateway.do")
            );
            if (alipayForm) {
              alipayForm.submit();
            } else {
              console.warn("找不到支付宝表单");
            }
            // document.forms[0].submit(); //重点--这个才是跳转页面的核心,获取第一个表单并提交
          });
          return;
        } else {
          this.$message({
            type: "success",
            message: info,
          });
          this.$router.push({
            path: "/thinktank/thinktankMy",
            query: {
              downloadUrl: data.url,
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;

  .top {
    // background-color: #6fffff22;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 165px;
    border-radius: 4px;
    background-image: url(~@/assets/image/thinktank/bg2.webp),
      url(~@/assets/image/thinktank/bg.webp);
    background-size: 155px 141px, 100% 100%;
    background-repeat: no-repeat;
    background-position: 45px 61px, 0px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    .title {
      font-size: 28px;
      font-weight: 500;
      color: #262626;
    }
    .search {
      width: 720px;
      height: 50px;

      box-sizing: border-box;
      border-radius: 4px;
      border: 1.5px solid #ffffff;
      background: rgba(255, 255, 255, 0.6);
      display: flex;
      padding: 0 10px;
      align-items: center;
      &::v-deep .el-input {
        .el-input__inner {
          padding-left: 0px;
          border: none;
          background: transparent;
        }
      }
    }
    .button {
      width: 76px;
      height: 34px;
      border-radius: 4px;
    }
  }
  .content {
    background: #ffffff;
    margin-top: 16px;
    &_top {
      padding-left: 16px;
      padding-top: 14px;
      padding-bottom: 14px;
      display: flex;
      flex-direction: column;
      row-gap: 14px;
      &_row {
        display: flex;
        align-items: center;
        position: relative;
      }
      &_search {
        display: flex;
        align-items: center;
        &_label {
          font-size: 14px;
          font-weight: 350;
          line-height: normal;
          color: #666666;
          margin-right: 20px;
        }
        &_list {
          display: flex;
          gap: 16px;
          &_item {
            height: 32px;
            padding: 6px 8px;
            border-radius: 4px;

            font-size: 14px;
            font-weight: 350;
            line-height: normal;
            color: #666666;
            display: flex;
            align-items: center;
            gap: 4px;
            cursor: pointer;
          }
          .active {
            background: #f2f3f5;
            color: #262626;
            font-weight: normal;
          }
        }
      }
      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0px;
        right: 16px;
        img {
          cursor: pointer;
          width: 34px;
          height: 34px;
        }
      }
    }
    &_main {
      padding: 0 16px;
      .setting {
        display: flex;
        color: #eeeeee;
        .text {
          color: #0062ff;
          cursor: pointer;
        }
      }
      .card {
        display: flex;
        flex-wrap: wrap;
        grid-template-columns: repeat(5, 1fr); /* 固定 5 列 */
        gap: 16px; /* 行列间距 */
      }
    }
    .pagination {
      @include paginationStyle;
    }
  }
}
.sort {
  position: relative;
  width: 8px;
  line-height: normal;
  display: flex;
  align-items: center;
  height: 100%;
  .down {
    position: absolute;
    right: 0;
  }
  .up {
    position: absolute;
    left: 0;
  }
}
.isDown {
  .down {
    color: #0062ff;
  }
}
.isUp {
  .up {
    color: #0062ff;
  }
}
</style>
